import { takeEvery } from 'redux-saga/effects';
import { getLogger } from '../../logger';
import { createHttpSaga, createHttpActions } from '../../redux/http-descriptor';

const logger = getLogger('products');
const importLogger = getLogger('CarDataImport');

export function* watchActions() {
  logger.debug('Setup saga watcher for Car Data Import', createHttpActions('carDataImport').request);
  yield takeEvery(
    createHttpActions('carDataImport').request,
    createHttpSaga('carDataImport', 'get', importLogger, vin => `/api/cardataimport/${vin}.json`)
  );

  logger.debug(
    'Setup saga watcher for set Item for Car Data Import',
    createHttpActions('carDataImportItem', 'put').request
  );
  yield takeEvery(
    createHttpActions('carDataImportItem', 'put').request,
    createHttpSaga(
      'carDataImportItem',
      'put',
      importLogger,
      payload => `/api/cardataimport/${payload.vin}.json`,
      payload => ({ item: payload.itemId })
    )
  );
}

export default [watchActions];
